import { createFeatureSelector } from '@ngrx/store';
import { RouteHistory } from './route-history.state';

export const routeHistoryFeatureKey = 'routeHistory';
export const selectRouteHistory = createFeatureSelector<RouteHistory>(routeHistoryFeatureKey);
